import React from 'react'
import { VscFilePdf, VscFileZip, VscFile } from 'react-icons/vsc'
import useBoolean from 'utils/hooks/useBoolean'
import Dialog from '../Dialog'

const BYTE = 1000
const getKB = (bytes) => Math.round(bytes / BYTE)

const FileIcon = ({ children }) => {
    return <span className="text-4xl">{children}</span>
}

const FileItem = (props) => {
    const [openPreviewDialog, setOpenPreviewDialog] = useBoolean(false)
    const { file, children, isFileInTooltip = false } = props
    const { type, name, size, s3Url, fileName } = file

    const renderThumbnail = () => {
        const isImageFile = type.split('/')[0] === 'image'

        if (isImageFile) {
            return (
                <img
                    className="upload-file-image"
                    src={s3Url || URL.createObjectURL(file)}
                    alt={`file preview ${name || fileName}`}
                />
            )
        }

        if (type === 'application/zip') {
            return (
                <FileIcon>
                    <VscFileZip />
                </FileIcon>
            )
        }

        if (type === 'application/pdf') {
            return (
                <FileIcon>
                    <VscFilePdf />
                </FileIcon>
            )
        }

        return (
            <FileIcon>
                <VscFile />
            </FileIcon>
        )
    }

    return (
        <div
            className={`upload-file bg-${
                isFileInTooltip
                    ? 'bg-theme-dark-color'
                    : 'theme-border-light-color'
            } border-0 max-h-8`}
        >
            <Dialog
                isOpen={openPreviewDialog}
                onClose={() => setOpenPreviewDialog.off()}
                onRequestClose={() => setOpenPreviewDialog.off()}
                // Kept below commented code for further styling work
                fullWidth={true}
                height="calc(100% - 10rem)"
                className="place-items-center"
            >
                <iframe
                    src={s3Url || URL.createObjectURL(file)}
                    className="h-full w-full mx-0"
                />
            </Dialog>
            <div className="flex w-28">
                {/* <div className="upload-file-thumbnail">{renderThumbnail()}</div> */}
                <div
                    className="upload-file-info"
                    onClick={() =>
                        !isFileInTooltip && setOpenPreviewDialog.on()
                    }
                >
                    {/* <h6 className="upload-file-name text-theme-color text-clip font-medium"> */}
                    <h6
                        className={`upload-file-name cursor-pointer text-${
                            isFileInTooltip ? 'white' : 'theme-color'
                        } text-${
                            isFileInTooltip ? 'xs' : 'sm'
                        } whitespace-nowrap text-ellipsis overflow-hidden max-w-2`}
                    >
                        {name || fileName}
                    </h6>
                    {/* <span className="upload-file-size text-theme-color">
                        {getKB(size)} kb
                    </span> */}
                </div>
            </div>
            {children}
        </div>
    )
}

export default FileItem
